import Api, { baseURL, requestOptionsGET } from '../api';
import newFetch from '../utils/newFetch';

const state = {
  xmlsNfe: []
};

const getters = {
  getXmlsNfe: (state) => state.xmlsNfe
};

const mutations = {
  setXmlsNfeByid(state, payload) {
    state.xmlsNfe = payload;
  }
};

const actions = {
  fetchQuantitiesNfesAndDeliveriesByCityAndSender(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(
        baseURL + Api.getQuantitiesNfesAndDeliveriesByCity + id,
        requestOptionsGET(localStorage.getItem('accessToken'))
      )
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  },
  fetchQuantitiesHierarchyRecords(_, id) {
    return new Promise((resolve, reject) => {
      newFetch(baseURL + Api.getQuantitiesHierarchyRecords + id, requestOptionsGET(localStorage.getItem('accessToken')))
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => reject(err));
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
